module.exports = __webpack_public_path__ + "img/stock.fd8873b3.jpg";